import styled, { css } from 'styled-components'
import media from 'styled-media-query'

export const Wrapper = styled.div`
  width: 100%;
  min-height: calc(100vh - 152px);
  padding-left: 82px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`

export const CardsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;

  ${media.lessThan('large')`
    grid-template-columns: 1fr;
    gap: 0;
  `}
`

export const Card = styled.div`
  ${({ theme }) => css`
    border-radius: 1rem;
    border-left: 6px solid ${theme.colors.primary};
    border-right: 6px solid ${theme.colors.primary};
    font-family: ${theme.font.comfortaa};
    box-shadow: 0px 2px 5px ${theme.colors.black};
    max-width: 500px;
    min-height: 700px;
    margin: 16px 20px;
    background: ${theme.colors.white};
  `}
`

export const CardTitle = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${theme.colors.black};
    font-weight: ${theme.font.bold};
    font-size: ${theme.font.sizes.large};
    padding: 24px;

    ${media.lessThan('small')`
      font-size: ${theme.font.sizes.medium};
      padding: 14px;
    `}
  `}
`

export const CardSubtitle = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 0 10px;
    font-weight: ${theme.font.bold};
    font-size: ${theme.font.sizes.large};
    color: ${theme.colors.primary};
    height: 40px;

    svg {
      height: 30px;
      width: 30px;
      margin-right: 8px;
    }

    ${media.lessThan('small')`
      font-size: ${theme.font.sizes.xsmall};
      padding: 14px;

      svg {
        display: none;
      }
    `}
  `}
`

export const CardPlanPrice = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: ${theme.font.sizes.small};
    padding: 32px;
    font-weight: ${theme.font.bold};
  `}
`

export const CardPlanTextsContainer = styled.div`
  font-weight: 200;
  padding: 28px;
`

export const CardPlanTextsTitle = styled.h3`
  ${({ theme }) => css`
    padding: 18px 38px;
    font-size: ${theme.font.sizes.normal};
    font-family: ${theme.font.comfortaa};
    font-weight: ${theme.font.xbold};
  `}
`

export const CardPlanTexts = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    color: ${theme.colors.xgray};
    padding: 8px 0;

    svg {
      height: 30px;
      width: 30px;
      margin-right: 8px;
    }
  `}
`

export const PlanMessage = styled.div`
  ${({ theme }) => css`
    color: ${theme.colors.gray};
    margin: 32px 0 8px 0;
    padding: 0 11%;

    u {
      color: ${theme.colors.black};
      font-weight: ${theme.font.bold};
    }
  `}
`
